<template>
  <v-card>
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card-title class="float-left">
      Détails d'une région web : {{ regionWeb ? regionWeb.translations.fr.name : '-' }}
    </v-card-title>

    <LocalSwitcher
      @updateCurrentLocale="updateCurrentLocale($event)"
    ></LocalSwitcher>

    <v-card-text>
      <v-form
        v-model="valid"
        class="multi-col-validation mt-5"
        @submit.prevent="checkForm"
      >
        <p v-if="errors.length">
          <v-alert
            v-for="(error, index) in errors"
            :key="index"
            text
            dense
            type="error"
          >
            {{ error.title }}
          </v-alert>
        </p>

        <Snackbar
          v-if="successMessage"
          :key="generateUniqueId()"
          :snackbar-state="snackbar"
          :success-message="successMessage"
        ></Snackbar>

        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-tabs
              grow
            >
              <v-tab>
                <v-icon left>
                  {{ icons.mdiPencil }}
                </v-icon>
                CMS
              </v-tab>
              <v-tab>
                <v-icon left>
                  {{ icons.mdiHelpCircleOutline }}
                </v-icon>
                FAQ
              </v-tab>
              <v-tab>
                <v-icon left>
                  {{ icons.mdiCameraOutline }}
                </v-icon>
                Images
              </v-tab>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="6"
                        md="6"
                      >
                        <h4>Description de la région web</h4>
                        <br>
                        <v-text-field
                          v-model="name[currentLocale]"
                          label="Nom"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Nom"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="slug[currentLocale]"
                          label="Slug"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Slug"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="title[currentLocale]"
                          label="Titre"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Titre"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="entityData.latitude"
                          label="Latitude"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Latitude"
                          hide-details
                        ></v-text-field>

                        <v-text-field
                          v-model="entityData.longitude"
                          label="Longitude"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Longitude"
                          hide-details
                        ></v-text-field>

                        <v-switch
                          v-model="entityData.enabled"
                          :label="'Etat : ' + (entityData.enabled === true ? 'Activé' : 'Désactivé')"
                        ></v-switch>

                        <h4>SEO</h4>
                        <br>

                        <v-text-field
                          v-model="seoTitle[currentLocale]"
                          label="Titre SEO"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Titre SEO"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="seoDescription[currentLocale]"
                          label="Description SEO"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Description SEO"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="seoKeywords[currentLocale]"
                          label="Mot clés"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Mot clés"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="prefix1[currentLocale]"
                          label="Préfixe 1"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Préfixe 1"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="prefix2[currentLocale]"
                          label="Préfixe 2"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Préfixe 2"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <h4>Sélection d'activités</h4>
                        <br>
                        <v-select
                          v-model="activitySelection"
                          :items="activities"
                          item-text="text"
                          item-value="value"
                          multiple
                          outlined
                          chips
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="6"
                        md="6"
                      >
                        <div class="content-ckeditor-region">
                          <h4>Extrait</h4>
                          <br>
                          <ckeditor
                            v-model="excerpt[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>

                        <br>

                        <div class="content-ckeditor-region">
                          <h4>Description courte</h4>
                          <br>
                          <ckeditor
                            v-model="shortDescription[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>

                        <br>

                        <div class="content-ckeditor-region">
                          <h4>Description Longue</h4>
                          <br>
                          <ckeditor
                            v-model="longDescription[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>

                        <br>

                        <div class="content-ckeditor-region">
                          <h4>Description bas de page</h4>
                          <br>
                          <ckeditor
                            v-model="bottomDescription[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item eager>
                <v-card flat>
                  <v-card-text>
                    <FaqEditor
                      ref="faqEditor"
                      :value="entityData.faqBlocks"
                      :editor="editor"
                      :editor-config="editorConfig"
                    ></FaqEditor>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo principale"
                      image-name="mainImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>

                    <br>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo mobile"
                      image-name="mobileImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <h4>Texte bannière</h4>
                    <br>

                    <v-text-field
                      v-model="txtZone1[currentLocale]"
                      label="Texte zone 1"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Texte zone 1"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="txtZone2[currentLocale]"
                      label="Texte zone 2"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Texte zone 2"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              class="mt-5 mr-2"
              color="primary"
              :disabled="!valid"
              type="submit"
            >
              Valider
            </v-btn>

            <v-btn
              class="mt-5"
              text
              :to="{ name: 'regionWebList' }"
            >
              Retour
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { mdiEyeOutline, mdiEyeOffOutline, mdiCameraOutline, mdiMinusBox, mdiPencil, mdiCompassRose, mdiThumbUp, mdiSkiWater, mdiHelpCircleOutline } from '@mdi/js'
import config from '../../../config'
import LocalSwitcher from '@/components/Common/LocalSwitcher'
import Snackbar from '@/components/Common/Snackbar'
import Loader from '@/components/Common/Loader'
import ImageHandler from '@/components/Common/ImageHandler'
import FaqEditor from '@/components/Common/FaqEditor'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import FullEditor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  components: {
    FaqEditor,
    ImageHandler,
    Snackbar,
    LocalSwitcher,
    Loader,
    ckeditor: CKEditor.component
  },
  data () {
    return {
      valid: false,
      errors: [],
      snackbar: false,
      successMessage: null,
      loading: false,
      currentLocale: 'fr',
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiCameraOutline,
        mdiMinusBox,
        mdiPencil,
        mdiCompassRose,
        mdiSkiWater,
        mdiHelpCircleOutline,
        mdiThumbUp
      },
      editor: FullEditor,
      editorConfig: {
        toolbar: {
          shouldNotGroupWhenFull: true
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
          ]
        },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        },
        simpleUpload: {
          uploadUrl: config.apiUrl + '/api/medias',
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        }
      },
      id: [],
      name: [],
      slug: [],
      title: [],
      excerpt: [],
      shortDescription: [],
      longDescription: [],
      bottomDescription: [],
      seoTitle: [],
      seoDescription: [],
      seoKeywords: [],
      prefix1: [],
      prefix2: [],
      txtZone1: [],
      txtZone2: [],
      activities: [],
      activitySelection: [],
      regionWeb: null,
      entityData: {
        id: null,
        enabled: null,
        latitude: null,
        longitude: null,
        currentLocale: 'fr',
        defaultLocale: 'fr',
        newTranslations: {},
        faqBlocks: [],
        mainImage: {
          id: null,
          title: null
        },
        mobileImage: {
          id: null,
          title: null
        }
      }
    }
  },
  created () {
    this.getRegionWeb()
    this.getActivities()
  },
  methods: {
    checkForm () {
      this.errors = []

      if (this.valid) {
        this.putRegionWeb()
      }
    },
    apiUrl () {
      return config.apiUrl
    },
    getActivities () {
      this.loading = true

      Vue.prototype.$http
        .get(config.apiUrl + '/api/seo/activities', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            const activities = response.data

            for (let i = 0; i < activities.length; i++) {
              const currentActivity = activities[i]

              this.activities.push({
                text: currentActivity.translations.fr.name,
                value: currentActivity.id
              })
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getRegionWeb () {
      const regionWebId = this.$route.params.regionWebId

      this.loading = true

      return Vue.prototype.$http
        .get(config.apiUrl + '/api/location/regions-web/' + regionWebId, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.activitySelection = []
            this.id = []
            this.name = []
            this.slug = []
            this.title = []
            this.excerpt = []
            this.shortDescription = []
            this.longDescription = []
            this.bottomDescription = []
            this.seoTitle = []
            this.seoDescription = []
            this.seoKeywords = []
            this.prefix1 = []
            this.prefix2 = []
            this.txtZone1 = []
            this.txtZone2 = []

            this.regionWeb = response.data
            this.entityData.id = this.regionWeb.id
            this.entityData.enabled = this.regionWeb.enabled
            this.entityData.latitude = this.regionWeb.latitude
            this.entityData.longitude = this.regionWeb.longitude
            this.entityData.newTranslations = {}
            this.entityData.faqBlocks = (this.regionWeb.faqBlocks || []).filter(faqBlock => faqBlock.source !== 'imported')

            if (this.regionWeb.mainImage) {
              this.entityData.mainImage = this.regionWeb.mainImage
            }

            if (this.regionWeb.mobileImage) {
              this.entityData.mobileImage = this.regionWeb.mobileImage
            }

            this.entityData.regionCatalogue = this.regionWeb.regionCatalogue

            this.entityData.activities = this.regionWeb.activities

            if (this.entityData.activities) {
              for (let i = 0; i < this.entityData.activities.length; i++) {
                const currentActivity = this.entityData.activities[i]

                this.activitySelection.push(currentActivity.id)
              }
            }

            const translations = this.regionWeb.translations

            for (const [currentKey] of Object.entries(translations)) {
              let currentTranslation = translations[currentKey]

              this.id[currentKey] = currentTranslation.id
              this.name[currentKey] = currentTranslation.name
              this.slug[currentKey] = currentTranslation.slug
              this.title[currentKey] = currentTranslation.title
              this.excerpt[currentKey] = currentTranslation.excerpt
              this.shortDescription[currentKey] = currentTranslation.shortDescription
              this.longDescription[currentKey] = currentTranslation.longDescription
              this.bottomDescription[currentKey] = currentTranslation.bottomDescription
              this.seoTitle[currentKey] = currentTranslation.seoTitle
              this.seoDescription[currentKey] = currentTranslation.seoDescription
              this.seoKeywords[currentKey] = currentTranslation.seoKeywords
              this.prefix1[currentKey] = currentTranslation.prefix1
              this.prefix2[currentKey] = currentTranslation.prefix2
              this.txtZone1[currentKey] = currentTranslation.txtZone1
              this.txtZone2[currentKey] = currentTranslation.txtZone2
            }

            this.valid = true
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    putRegionWeb () {
      this.loading = true
      this.valid = false
      this.successMessage = null
      this.entityData.newTranslations = {}

      this.handleTranslations([
        'id',
        'name',
        'slug',
        'title',
        'excerpt',
        'shortDescription',
        'longDescription',
        'bottomDescription',
        'seoTitle',
        'seoDescription',
        'seoKeywords',
        'prefix1',
        'prefix2',
        'txtZone1',
        'txtZone2'
      ])

      const selectedActivities = []

      for (let i = 0; i < this.activitySelection.length; i++) {
        const currentActivity = this.activitySelection[i]

        selectedActivities.push({
          id: (typeof currentActivity === 'object') ? currentActivity.value : currentActivity
        })
      }

      this.entityData.activities = selectedActivities

      const payload = {...this.entityData}

      if (this.$refs.faqEditor) {
        payload.faqBlocks = this.$refs.faqEditor.serializeFaqBlocks()
      }

      Vue.prototype.$http
        .put(config.apiUrl + '/api/location/regions-web/' + this.entityData.id, payload, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.getRegionWeb().then(() => {
              this.snackbar = true
              this.successMessage = 'Région web mise à jour avec succès.'
              this.valid = true
            })

            return
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          this.successMessage = null

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    handleTranslations (attributes) {
      for (let i = 0; i < attributes.length; i++) {
        const currentAttribute = attributes[i]

        for (const [currentKey, currentValue] of Object.entries(this[currentAttribute])) {
          let translation = {
            locale: currentKey,
            empty: false
          }

          translation[currentAttribute] = currentValue

          const currentObjState = this.entityData.newTranslations[currentKey]

          this.entityData.newTranslations[currentKey] = {...currentObjState, ...translation}
        }
      }
    },
    updateCurrentLocale (locale) {
      this.currentLocale = locale
      this.successMessage = null
    },
    updateEntityData (updatedData) {
      this.entityData = updatedData
    },
    updateLoading (loading) {
      this.loading = loading
    },
    updateSnackbar (snackbar) {
      this.snackbar = snackbar
    },
    updateSuccessMessage (successMessage) {
      this.successMessage = successMessage
    },
    updateValid (valid) {
      this.valid = valid
    }
  }
}
</script>
